import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import copy from 'copy-to-clipboard'
import { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import TextArea from 'modules/core/components/Inputs/TextArea'
import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  onClose: () => void
}

const IndeedModal = ({ onClose }: Props) => {
  const copyText = (text: string) => (event: React.SyntheticEvent<Element, Event>) => {
    event.preventDefault()
    text && copy(text)
    app.setFlash({
      type: 'correct',
      message: i18n.t('common.copied'),
    })
  }

  const {
    access: { firstName },
    company: { name: companyName, publicUrl },
  } = useCurrentSession()

  const requestDescription = i18n.t('app_store_v2.integrations.indeed.modal.request_description', {
    name: firstName,
    company: companyName,
    careers_link: publicUrl,
  })

  return (
    <Modal
      illustration="sync"
      title={i18n.t('app_store_v2.integrations.indeed.modal.title')}
      description={i18n.t('app_store_v2.integrations.indeed.modal.description')}
      onClose={onClose}
      onSubmit={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="primary" onClick={onClose}>
            {i18n.t('common.ok')}
          </Button>
        </>
      }
    >
      <Box gap="s24">
        <TextArea
          readonly
          label={i18n.t('app_store_v2.integrations.indeed.modal.request')}
          field={new Field(requestDescription, 'string')}
        />
        <Button onClick={copyText(requestDescription)} type="secondary">
          {i18n.t('app_store_v2.integrations.indeed.modal.request_copy')}
        </Button>
      </Box>
    </Modal>
  )
}

export default observer(IndeedModal)
